module.exports = __webpack_public_path__ + "img/speak.dbedfa7e.png";